import {
  ADD_ASYNC,
  CHANGE_EXCLUDED_TAGS,
  CHANGE_INCLUDED_TAGS,
  CHANGE_NAME,
  DELETE_MANY_ASYNC,
  RESET_TAGS_VALUES,
  SET_TAGS_PAGE,
  SET_TAGS_SEARCH,
  TAGS_REQUEST_ASYNC,
} from './constants'

const addSegment = () => ({ type: ADD_ASYNC.INITIATE })
const addSegmentCancel = () => ({ type: ADD_ASYNC.CANCEL })
export const addSegmentSuccess = (data) => ({
  type: ADD_ASYNC.SUCCESS,
  payload: { data },
})
export const addSegmentError = (error) => ({ type: ADD_ASYNC.ERROR, error })

const deleteSegments = () => ({ type: DELETE_MANY_ASYNC.INITIATE })
const deleteSegmentsCancel = () => ({ type: DELETE_MANY_ASYNC.CANCEL })
export const deleteSegmentsSuccess = (data) => ({
  type: DELETE_MANY_ASYNC.SUCCESS,
  payload: { data },
})
export const deleteSegmentsError = (error) => ({
  type: DELETE_MANY_ASYNC.ERROR,
  error,
})

export const fetchTags = () => ({ type: TAGS_REQUEST_ASYNC.INITIATE })
export const fetchTagsCancel = () => ({ type: TAGS_REQUEST_ASYNC.CANCEL })
export const fetchTagsSuccess = (data) => ({
  type: TAGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchTagsError = (error) => ({
  type: TAGS_REQUEST_ASYNC.ERROR,
  error,
})
export const setTagsPage = (page) => ({
  type: SET_TAGS_PAGE,
  payload: { page },
})
export const setTagsSearch = (search) => ({
  type: SET_TAGS_SEARCH,
  payload: { search },
})

const changeIncludedTags = (value) => ({
  type: CHANGE_INCLUDED_TAGS,
  payload: { value },
})
const changeExcludedTags = (value) => ({
  type: CHANGE_EXCLUDED_TAGS,
  payload: { value },
})
const resetTagsValues = () => ({ type: RESET_TAGS_VALUES })

export default {
  // to props
  addSegment,
  addSegmentCancel,
  deleteSegments,
  deleteSegmentsCancel,
  fetchTags,
  setTagsPage,
  setTagsSearch,
  changeIncludedTags,
  changeExcludedTags,
  resetTagsValues,
}
